import React from 'react';
import { withRouter } from 'react-router-dom';


function DemoInstructions (props) {
    return (
      <div className="container mt-5 py-5">
        <div className="row d-flex">
          <h2 className="mb-4">Demo instructions.</h2>
            <ul>
              <li>Create an email with your desired content</li>
              <li>Send the email to <a href="mailto:dev@dev.linkoln.link">dev@dev.linkoln.link</a></li>
              <li>Receive a Linkoln Email link to your content.</li>
            </ul>
        </div>
      </div>
    );
}

export default withRouter(DemoInstructions);
